import axios from "axios";

export const state = {
    cart: [],
    products: "",
    total_cart: "",
    save_status: false,
    sale_save_status: false,
    invoice: [],
    invoice_id:'',
    invoices: {
        data: [],
        meta: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 10,
            to: 0,
            total: 0,
        },
        isServerPaginated: false,
        
    },
    filter_status: false,

};
export const getters = {
    TotalCart: state => state.total_cart,
    InvoiceCart: state => state.cart.data,
    SaveStatus: state => state.save_status,
    SaleSaveStatus: state => state.sale_save_status,
    Invoices: state => state.invoices.data,
    Invoice: state => state.invoice.data,
    InvoiceId: state => state.invoice_id,
    InvoicesPagination: state => state.invoices.meta,
    isServerPaginated: state => state.invoices.isServerPaginated,
    filterStatus: state => state.filter_status,

};
export const mutations = {
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_INVOICE_SAVE_STATUS(state, newValue) {
        state.sale_save_status = newValue
    },
    SET_CART(state, newValue) {
        state.cart = newValue
    },

    SET_TOTAL_CART(state, newValue) {
        state.total_cart = newValue
    },
    SET_INVOICES(state, response) {
        if (response && response.data) {
                state.invoices.data = response.data;
    
                if (response.meta && response.links) {
                    state.invoices.meta = response.meta;
                    state.invoices.isServerPaginated = true;
                } else {
                    state.invoices.meta = {
                        current_page: 1,
                        from: 1,
                        last_page: 1,
                        per_page: response.data.length ||10,
                        to: response.data.length || 0,
                        total: response.data.length || 0,
                    };
                    state.invoices.isServerPaginated = false;
                }
            } else {
                state.invoices.data = [];
                state.invoices.meta = { current_page: 1, from: 1, last_page: 1, per_page: 10, to: 0, total: 0 };
                state.invoices.isServerPaginated = false;
            }
    },
    SET_INVOICE(state, newValue) {
        state.invoice = newValue
    },
    SET_INVOICE_ID(state, newValue) {
        state.invoice_id = newValue
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },
};
export const actions = {

    // add products to invoice cart
    addToCart({ dispatch, commit }, data) {
        commit('SET_INVOICE_SAVE_STATUS', true)
        axios.post('invoice_cart', data).then(() => {
            commit('SET_INVOICE_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
        }).catch(() => {
            commit('SET_INVOICE_SAVE_STATUS', false)
            let message = { 'msg': "Failed to add Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // edit invoice cart
    editCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`invoice_cart/${data.id}`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status == 200) {
                let message = { 'msg': "Product edited successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to edit Product" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to edit Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // delete items from invoice cart
    deleteCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`invoice_cart/${data.id}`).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotCart')
            if (response.status == 200) {
                let message = { 'msg': "Product deleted from cart successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to delete Product from cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': data.name + ' adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },



    // Process Invoice
    saveInvoice({ dispatch, commit }, data) {
        commit('SET_INVOICE_SAVE_STATUS', true)
        axios.post(`invoices`, data).then(response => {
            commit('SET_INVOICE_SAVE_STATUS', false)

            if (response.status == 200) {
                let message = { 'msg': "Invoice Recorded successfully" }
                dispatch('notification/success', message, { root: true })
                dispatch('fetchCart')
                dispatch('fetchTotCart')
            } else if (response.status == 202) {
                let message = { 'msg': "Failed to record Sale" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_INVOICE_SAVE_STATUS', false)
            let message = { 'msg': "Failed to record an Invoice" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // delete Invoice
    deleteInvoice({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`invoices/${data.id}`).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchInvoices')
            if (response.status == 200) {
                let message = { 'msg': "Invoice Deleted successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to delete Invoice" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': data.name + ' Deleting Failed' }
            dispatch('notification/error', message, { root: true })
        })
    },
    // get invoice cart
    fetchCart({ commit }) {
        axios.get('invoice_cart').then(cart => {
            commit('SET_CART', cart.data)
        })
    },
    // 

    // get invoice cart Total
    fetchTotCart({ commit }) {
        axios.get('total_invoice_cart').then(total => {
            commit('SET_TOTAL_CART', total.data)
        })
    },
    // get invoices
    fetchInvoices({ commit, dispatch }, payload={}) {
        commit('SET_FILTER_STATUS', true);
                let apiPayload = { ...payload };
                apiPayload.page = payload.page || 1;
                apiPayload.per_page = payload.per_page || 10;
        
                axios.get('invoices', { params: apiPayload })
                .then(response => {
                    commit('SET_INVOICES', response.data);
                    commit('SET_FILTER_STATUS', false);
                })
                .catch((error) => {
                    commit('SET_INVOICES', { 
                        data: [], 
                        meta:{}, 
                       
                    });
                    commit('SET_FILTER_STATUS', false);
                    let errorMsg = 'Failed to load LPOs.';
                    if (error.response && error.response.data && error.response.data.message) {
                        errorMsg = error.response.data.message;
                    }
                    dispatch('notification/error', { msg: errorMsg }, { root: true });
                });
    },
    // get a single invoice
    async fetchInvoice({ commit }, data) {
        return axios.get(`invoices/${data.id}`).then(cart => {
            commit('SET_INVOICE', cart.data)
        })
    },

    // Generate Invoice
    generateInvoice({ dispatch, commit }, id) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`invoices/${id}`).then(response => {
            commit('SET_SAVE_STATUS', false)
            if (response.status == 200) {
                commit('SET_INVOICE_ID', response.data.id)
            }else{
                let message = { 'msg': "Failed to generate Invoice, please try again" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': 'Failed to generate Invoice, please try again' }
            dispatch('notification/error', message, { root: true })
        })
    },

};